import styles from './accountContainer.scss';
import PaginationComponent from '../../Dashboard/Common/Pagination/pagination';
import ResponsiveViewManageAccount from './Presentational/responsiveViewManageAccount';
export default class AccountContainer extends React.Component {
    constructor(props) {
        super(props);
        this.isMobileView = app.appUtil.detectMobile();
        this.state = {
            innerTableLoader: false, mainTableLoader: false, accountDetails: {}, serviceAccountDetails: {}, globalError: false, totalCAAccount: 0,
            isError: false, serviceAccountIndex: this.isMobileView?[]:[0], noDataOnSearch: false, searchedData: [], searchDataServiceList: [], searchBarInfo: { searchText: '', isError: '' },
            isSearchModeOn: false, sortDirection: 'ASC', currentPage: 1, sortDescArrow: false, searchCaAddress: {}, toggleRowId: [],savingChangesArr:[],toggleErrorArr:[],clickOnXBtn:false,
            noOfShowMoreSAList:3,saFilteredList:[],showMoreLink:false,showLessLink:false,spinner:true,isOpenDropDown:false,totalManagedAccount:this.props.totalManageAcc
        };
        this.downarrowblack = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_chevron_green.svg';
        this.popupRef = React.createRef();
        this.ACCOUNTS_PER_PAGE = this.props.accountsPerPage;
        this.serviceAccountList = [];
    }
    componentDidMount() {
        if(this.props.manageAccDetails===null){
            this.fetchAccountDetails();}
        else{
            this.setState({accountDetails: this.props.manageAccDetails, globalError: false, totalCAAccount: this.props.manageAccDetails.totalCactCount, mainTableLoader: false, isError: false, innerTableLoader: false });
        }
        document.addEventListener('click', this.handClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handClickOutside);
      }
      handClickOutside = (event) => {
        if (this.popupRef.current && !this.popupRef.current.contains(event.target)) {
          { this.setState({ isOpenDropDown: false }); }
        }
      }
    

    fetchAccountDetails = (offSet, limit, sortOption, isService, contractAccountNumber) => {
        if (isService) {
            this.setState({ innerTableLoader: true });
        } else {
            this.setState({ mainTableLoader: true,serviceAccountIndex:this.isMobileView?[]:[0] });
        }
        app.settingsService.getAccountDetails(isService, contractAccountNumber, sortOption, offSet, limit).then(
            (response) => {
                this.setState({ accountDetails: isService ? this.state.accountDetails : response, globalError: false, totalCAAccount: isService ? this.state.totalCAAccount : response.totalCactCount, mainTableLoader: false, isError: false, serviceAccountDetails: isService ? response : this.state.serviceAccountDetails, innerTableLoader: false });
                app.appService.setLocalStorage('totalCact', response.totalCactCount);
                if(response.totalCactCount>1){
                this.props.showAccountsTab();}
            }, (error) => {
                this.setState({ globalError: true, innerTableLoader: false, isError: true, mainTableLoader: false });
            });
    }

    fetchAccountDetailsOnSearch = (service, contractAccountNumber) => {
        this.setState({ mainTableLoader: true, serviceAccountIndex: [], noDataOnSearch: false });
        const serviceAccountNo = this.state.searchBarInfo.searchText && /^8/.test(this.state.searchBarInfo.searchText);
        let reqObj = {
            sortOption: "ContractNumber",
            coOffset: 0,
            colimit: 3,
            txnName:"Combined",
            sortDirection:"ASC"
        };
        if(serviceAccountNo){
            reqObj.contractNumber = contractAccountNumber;
        }else{
            reqObj.contractAccountNumber = contractAccountNumber;
        }
        let search = "search";
        app.settingsService.getSADetails(reqObj).then(
            (response) => {
                if(response && !response.errorCode){
                    window.aUtils ? window.aUtils.sendAAEvent("account | searchbar", `settings|accounts|none|multi_grid|page|searchtype=accountnum`) : null;                                     

                    this.setState({
                        searchCaAddress: response.caList[0].custAddress, searchedData: response.caList, searchDataServiceList: response.customerAccountList[0].serviceAccountList, isError: false, mainTableLoader: false,
                        noDataOnSearch: response.caList.length === 0,serviceAccountIndex:[0]
                   });
                }else{
                    this.setState({noDataOnSearch:true,mainTableLoader: false, isError: true});
                }
            }, (error) => {
                this.setState({ noDataOnSearch: true, mainTableLoader: false, isError: true });
            });
    }

    handleSearchEvents(e, triggerEvent) {
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'multi_grid', search:true
        };
        app.analyticsService.addPageLevelData('eventCapturing', events);
        app.logger.getLogger().info('entering handleSearchEvents function');
        switch (triggerEvent) {
            case 'onChange': {
                const reg = new RegExp(/^[0-9]+$/);
                if(reg.test(e.target.value) || e.target.value===""){
                    this.setState({ searchBarInfo: { searchText: e.target.value } });
                }
                break;
            }
            case 'onClear': {
                this.setState({ isSearchModeOn: false, serviceAccountIndex: this.isMobileView?[]:[0], sortDescArrow: false, sortDirection: 'ASC' });
                this.setState({ searchBarInfo: { searchText: '', isError: false } }, () => {
                    if(this.state.currentPage!==1 || this.state.searchedData.length){
                        this.setState({currentPage:1,sortDirection:"ASC",clickOnXBtn:true,searchDataServiceList:[], searchedData:[],noDataOnSearch:false,isSearchModeOn:false});
                        this.fetchAccountDetails(0,this.ACCOUNTS_PER_PAGE,'ASC');
                    }
                });
                break;
            }
            case 'onSearch': {
                e.preventDefault();
                if(this.state.searchBarInfo.searchText===''){
                    this.setState({searchBarInfo: { searchText: '', isError: false },});
                    if((this.state.noDataOnSearch || this.state.searchedData.length)){ 
                        this.setState({searchedData:[],searchDataServiceList:[],clickOnXBtn:true,sortDirection:"ASC",currentPage:1,noDataOnSearch:false,isSearchModeOn:false});
                        this.fetchAccountDetails(0,this.ACCOUNTS_PER_PAGE,'ASC');
                    }

                } else if(this.state.searchBarInfo.searchText.length < 10 || (this.state.searchBarInfo.searchText.charAt(0) === "7" && this.state.searchBarInfo.searchText.length === 12 ? false : ((this.state.searchBarInfo.searchText.charAt(0) === "8" && this.state.searchBarInfo.searchText.length === 10 || this.state.searchBarInfo.searchText.charAt(0) === "6" && this.state.searchBarInfo.searchText.length === 12) ? false : true))) {
                    this.setState({ searchBarInfo: {...this.state.searchBarInfo, isError:true}});
                } else if (isNaN(this.state.searchBarInfo.searchText)) {
                    this.setState({ searchBarInfo: { searchText: this.state.searchBarInfo.searchText, isError: true } });
                } else {
                    this.setState({  sortDescArrow: false, sortDirection: 'ASC',isSearchModeOn:true,clickOnXBtn:false });
                    this.fetchAccountDetailsOnSearch('search', this.state.searchBarInfo.searchText);
                }
                break;
            }
        }
    }
    handleClickOnXBtn=(value)=>{
        this.setState({clickOnXBtn:value});
    }

    handleCloseErrorBox=()=>{
        this.setState({ searchBarInfo: {...this.state.searchBarInfo, isError:false}});
    }

    fetchServiceAccountDetails = (contractAccountNumber, index, linkName) => {
        app.appService.setSessionstorage('totalServiceCount', JSON.parse(linkName.slice(0,1)));
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'multi_grid'
        },dropdown = this.state.serviceAccountIndex.includes(index) ?  'collapse' : 'expand',
        showAccDashSecData = this.state.serviceAccountIndex,
        foundIndex=showAccDashSecData.indexOf(index),
        scrollID = `scroll${index}`;
        app.analyticsService.addPageLevelData('eventCapturing', events);
        window.aUtils ? window.aUtils.sendAAEvent("dropdown", `settings|accounts|multi_grid|none|page|${linkName}_${dropdown}`) : null;
        if(this.isMobileView){
            let element = document.getElementById(scrollID);
            setTimeout(()=>{
                let top = element.getBoundingClientRect().top + document.documentElement.scrollTop - 50;

                window.scrollTo({top:top,behavior:"smooth"});
            },500);
            foundIndex>-1?showAccDashSecData.splice(foundIndex,1):showAccDashSecData=[index];
        }else{
            
            foundIndex>-1?showAccDashSecData.splice(foundIndex,1):showAccDashSecData.push(index);
        }

        this.setState({ serviceAccountIndex: [...showAccDashSecData],noOfShowMoreSAList:3 });  }
    handleClickSortOption = () => {
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'multi_grid'
        };
        app.analyticsService.addPageLevelData('eventCapturing', events);
        this.setState({ isOpenDropDown: !this.state.isOpenDropDown },()=>{
            window.aUtils ? window.aUtils.sendAAEvent("sort", `settings|accounts|multi_grid|none|page|${this.state.isOpenDropDown ? 'expand' : 'collapse'}`) : null;
        });
      }
    handleKeyDown=(event)=>{
        if(event.key === 'Enter'){
            this.handleClickSortOption();
        } }
    handleSortDropDown=()=>{
        return(
            <div className={styles.sceSortBlock} tabIndex={"0"} ref={this.popupRef} onKeyDown={this.handleKeyDown} onClick={this.handleClickSortOption}>
                <div className={styles.sceSortBlockMngAcnt}>Sort:</div>
                <div className={styles.sceSortDropDownBlock}>
                <div className={styles.sceSortSelectedValue}>{this.state.sortDirection==="ASC"?"Customer Account (ascending)":"Customer Account (descending)"}</div>
                {
                    this.state.isOpenDropDown && <div className={styles.sceSortDropDownBox}>
                    <div className={[styles.sceSortDropDownOptions, this.state.sortDirection === "ASC" ? styles.sceSOrtCloredDiv : ""].join(" ")} onClick={() => this.handleSort("ASC")} onKeyDown={(e)=>{e.key==="Enter"?this.handleSort("ASC"):null;}} tabIndex={"0"}>
                        <div className={styles.sceSortDropDownOption}>Customer Account (ascending)</div>
                        {this.state.sortDirection === "ASC" ? <div className={styles.sceSortDrpDownCheckIcon}><img src={drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_check.svg'} alt='check' /></div> : null}
                    </div>
                    <div className={[styles.sceSortDropDownOptions, this.state.sortDirection === "DESC" ? styles.sceSOrtCloredDiv : ""].join(" ")} onClick={() => this.handleSort("DESC")} tabIndex={"0"} onKeyDown={(e)=>{e.key==="Enter"?this.handleSort("DESC"):null;}}>
                        <div className={styles.sceSortDropDownOption}>Customer Account (descending)</div>
                        {this.state.sortDirection === "DESC" ? <div className={styles.sceSortDrpDownCheckIcon}><img src={drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_check.svg'} alt='check' /></div> : null}
                    </div>
                    </div>
                }
                </div>
                <div className={styles.sceSortArrowBtn}>
                <img alt='arrow' src={this.downarrowblack} className={this.state.isOpenDropDown ?styles.sceSortArrowBtnDown: styles.sceSortArrowBtnReverse} />
                </div>
            </div>
        );
    }

    handleToggleChange = (contractAccountNumber, businessPartnerName, relationShip, rowId, checked) => {
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'Display Customer Account on Dashboard'
        };
        app.analyticsService.addPageLevelData('eventCapturing', events);
        window.aUtils ? window.aUtils.sendAAEvent("Toggle", `settings|accounts|none|Display_Customer_Account_on_Dashboard|page|${checked ? 'toggle_on' : 'toggle_off'}`) : null;
        let isSearchedData = this.state.isSearchModeOn && this.state.searchedData && this.state.searchedData.length;
        let arr = this.state.accountDetails && this.state.accountDetails.caList ? this.state.accountDetails.caList : [];
        let reqObj = {};
        if (isSearchedData) {
            arr = this.state.searchedData;
        }

        let newArr = arr.map((item, ind) => {
            if (ind === rowId) {
                return { ...item, enrollmentStatus: checked ? 'A' : 'I' };
            }
            return item;
        });
        if (isSearchedData) {
            reqObj.cactList = newArr;
        } else {
            reqObj.caList = newArr;

        }
        let isExistSaving = this.state.savingChangesArr.includes(contractAccountNumber);
        let arrAccSaving =!isExistSaving?[...this.state.savingChangesArr,contractAccountNumber]:this.state.savingChangesArr;
        let newErr = this.state.toggleErrorArr.filter((item=>item!==contractAccountNumber));

        this.setState({ savingChangesArr: arrAccSaving,toggleErrorArr:newErr });
        let value = "D";
        if (checked) {
            value = "A";
        }
        let newSav = this.state.savingChangesArr.filter((item=>item!==contractAccountNumber));
        let totalManagedAccount = this.props.totalManageAcc;
        app.settingsService.updateEnrollmentStatus(contractAccountNumber, businessPartnerName, relationShip, value).then(
            (response) => {
                if(response && !response.errorCode){
                    let noOFActive = value==="A"?totalManagedAccount+1:totalManagedAccount-1;
                    this.props.setTotalMngAcc(noOFActive);
                    if (isSearchedData) {
                        this.setState({ savingChangesArr:newSav,  searchedData: newArr, });
                    } else {
                        this.setState({ savingChangesArr:newSav,  accountDetails: reqObj });
                    }
                }else{
                    this.setState({ savingChangesArr:newSav,toggleErrorArr:[...this.state.toggleErrorArr,contractAccountNumber], innerTableLoader: false, isError: true, mainTableLoader: false });

                }
                

            }, (error) => {
                this.setState({ savingChangesArr:newSav,toggleErrorArr:[...this.state.toggleErrorArr,contractAccountNumber], innerTableLoader: false, isError: true, mainTableLoader: false });
            });      
        
    }


    getPagination = () => {
        let totalPageCount = 1;
        let totalAccounts = this.state.totalCAAccount;
        totalPageCount = Math.ceil(totalAccounts / this.ACCOUNTS_PER_PAGE);
        return totalPageCount > 1 ? <PaginationComponent currentPage={this.state.currentPage} pageCount={totalPageCount} searchedData={this.state.searchedData} onPageChange={this.onPageChange.bind(this)} /> : null;}
    onPageChange = (value) => {
        document.querySelector('#searchBoxScroll').scrollIntoView();

        this.setState({ currentPage: value });
        let offset = this.ACCOUNTS_PER_PAGE * (value - 1);
        let limit = this.ACCOUNTS_PER_PAGE;
        let sortOrder = "ASC";
        if (this.state.sortDirection === "DESC") {
            sortOrder = "DESC";

            offset = this.state.totalCAAccount - ((value) * this.ACCOUNTS_PER_PAGE);
            if (offset < 0) {
                limit = this.ACCOUNTS_PER_PAGE - Math.abs(offset);
                offset = 0;
            }
        }
        this.fetchAccountDetails(offset, limit, sortOrder);  }

    handleSort = (sortingOrder) => {
        // let sortOrder = "ASC";
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'multi_grid'
        };
        app.analyticsService.addPageLevelData('eventCapturing', events);
        setTimeout(()=>{
            window.aUtils ? window.aUtils.sendAAEvent("sort", `settings|accounts|multi_grid|none|page|${sortingOrder}`) : null;
        },1000);
        let limit = this.ACCOUNTS_PER_PAGE;
        let offSet = this.ACCOUNTS_PER_PAGE * (this.state.currentPage - 1);
        if (sortingOrder === "DESC") {

            // sortOrder = "DESC";
            offSet = this.state.totalCAAccount - ((this.state.currentPage) * this.ACCOUNTS_PER_PAGE);
            if (offSet < 0) {
                limit = this.ACCOUNTS_PER_PAGE - Math.abs(offSet);
                offSet = 0;
            }
        }
        this.setState({ sortDescArrow: !this.state.sortDescArrow, sortDirection: sortingOrder });
        this.fetchAccountDetails(offSet, limit, sortingOrder);
    }
    setInnerTableLoader = (value)=>{
        this.setState({innerTableLoader:value}); }
    
    render() {
        let pageStartCount = (this.state.currentPage - 1) * this.ACCOUNTS_PER_PAGE + 1,pageEndCount = (this.state.currentPage * this.ACCOUNTS_PER_PAGE) < this.state.totalCAAccount ? (this.state.currentPage * this.ACCOUNTS_PER_PAGE) : this.state.totalCAAccount;
        
        return (
            <div id='searchBoxScroll'>
                {/* {spinner}
                {content} */}
                <ResponsiveViewManageAccount fetchServiceAccountDetails={this.fetchServiceAccountDetails.bind(this)} noDataOnSearch={this.state.noDataOnSearch} sortDirection={this.state.sortDirection} totalManagedAccount={this.props.totalManageAcc}
                pageStartCount={pageStartCount} pageEndCount={pageEndCount} savingChangesArr={this.state.savingChangesArr} toggleErrorArr={this.state.toggleErrorArr} handleSortDropDown={this.handleSortDropDown.bind(this)}
                setInnerTableLoader={this.setInnerTableLoader.bind(this)} handleToggleChange={this.handleToggleChange.bind(this)} serviceAccountIndex={this.state.serviceAccountIndex} handleClickOnXBtn={this.handleClickOnXBtn.bind(this)} clickOnXBtn={this.state.clickOnXBtn}
                accountsPerPage={this.ACCOUNTS_PER_PAGE} drupalContent={this.props.drupalContent} searchedData={this.state.searchedData} searchDataServiceList={this.state.searchDataServiceList} searchCaAddress={this.state.searchCaAddress} 
                isSearchModeOn={this.state.isSearchModeOn} sortDescArrow={this.state.sortDescArrow} handleSort={this.handleSort.bind(this)} getPagination={this.getPagination.bind(this)}
                serviceAccountDetails={this.state.serviceAccountDetails} mainTableLoader={this.state.mainTableLoader} innerTableLoader={this.state.innerTableLoader} accountDetails={this.state.accountDetails}
                fetchAccountDetails={this.fetchAccountDetails.bind(this)} handleSearchEvents={this.handleSearchEvents.bind(this)} searchBarInfo={this.state.searchBarInfo} totalCAAccount={this.state.totalCAAccount}
                saFilteredList={this.state.saFilteredList} handleCloseErrorBox={this.handleCloseErrorBox.bind(this)} showMoreLink={this.state.showMoreLink}  showLessLink={this.state.showLessLink} vintageYear={this.props.vintageYear} />

            </div>
        );
    }
}